const Fab = {
  defaultProps: {
    color: 'primary',
  },
};

export default Fab;
